import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import  List from 'src/components/List/List';
import getContentGroups from 'src/helpers/getContentGroups';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';

/**
 * @typedef {import("@prismicio/client").Content.ListSlice} ListSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ListSlice>} ListProps
 * @param { ListProps }
 */
const ListSlice = ({ slice }) => {
    const listItems = slice.items.length && getContentGroups(slice.items[0].items) || null;
    return (
        <>
            {slice.primary.display_icon ? (
                listItems.map((e, i) => (
                    <List
                        className={'mb-4'}
                        items={e}
                        key={i}
                        icon={{
                            faIcon: faCircleCheck,
                            background: 'bg-none',
                            colour: slice.primary.icon_colour ? `text-[${slice.primary.icon_colour}]` : undefined,
                            border: 'border-none',
                        }}
                    />
                ))
            ) : (
                <>
                    {slice?.items?.map((item, i) => (
                        <PrismicRichText field={item.items} key={i} />
                    ))}
                </>
            )}
        </>
    );
};

export default ListSlice;
